module.exports = __webpack_public_path__ + "media/images/img_house_selling_2-ed4c369d385214016dc57ef3076eb9a8.png";